import {Injectable} from '@angular/core';
import {ProjectMeasureService} from './project-measure.service';
import {TranslateService} from '@ngx-translate/core';
import {ProjectMeasureGraphicStateService} from '../project-measure-graphic-state/project-measure-graphic-state.service';
import {LocationsFormatterService} from './locations-formatter.service';
import {HelperService} from '../helper/helper.service';

const TEMPERATURE_DEVICE_TYPES_WITH_ONE_UNIT = ['pt_v5', 'v_sensor', 'g_sensor'];

@Injectable({
    providedIn: 'root'
})
export class SeriesFormatterService {

    private projectDeviceLocation: any;
    private deviceType: string;

    constructor(
        private measureService: ProjectMeasureService,
        private translateService: TranslateService,
        private graphicState: ProjectMeasureGraphicStateService,
        private locationsFormatterService: LocationsFormatterService,
        private helperService: HelperService) {
    }

    public pushSerieAndDatasForSmartOffsetsMode(datas, unit, callback: Function) {
        this.projectDeviceLocation = this.graphicState.getLocation(datas.location);
        this.deviceType = this.locationsFormatterService.getLocationDeviceType(this.projectDeviceLocation);
        if (!this.projectDeviceLocation || !this.deviceType) {
            return null;
        }

        if (this.doNotDisplaySeries(unit)) {
            return null;
        }
        const data = datas.measures.map((d, index) => {
            const measure = d[unit][1];
            const previousMeasure = datas.measures[index - 1] !== undefined ? datas.measures[index - 1][unit][1]
                : measure;   //  hack to avoid HighChart error
            const nextMeasure = datas.measures[index + 1] !== undefined ? datas.measures[index + 1][unit][1]
                : measure;   //  hack to avoid HighChart error
            if (nextMeasure === null) {
                return;
            }
            const offset = this.computeOffsetValue(measure, previousMeasure, nextMeasure);
            const el = {
                x: d[unit][0],
                title: offset.future.rounded === 0 ? '0' : offset.future.rounded,
                width: 50,
                events: {
                    click: () => callback(<MeasureInfosForSmartOffset>{
                        date: el.x,
                        offset,
                        locationId: datas.location
                    })
                }
            };
            return el;
        });

        return {
            type: 'flags',
            showInLegend: false,
            allowOverlapX: true,
            tooltip: {
                shared: true,
                pointFormat: '{point.title} | <b>{point.y} ' + this.translateService.instant(unit),
                valueDecimals: 4
            },
            cursor: 'pointer',
            data,
            id: datas.location + '_' + unit + '_flags',
            name: datas.location + '_' + unit + '_flags',
            color: this.helperService.getColor(unit, datas.location),
            onSeries: datas.location + '_' + unit,
            yAxis: unit,
            zIndex: 10000,
            boostThreshold: 1,
            showInNavigator: false,
        };
    }

    private computeOffsetValue(value, previousValue, nextValue) {

        const computeDifference = (value, valueToCompare) => {
            let exact = value - valueToCompare;
            if (this.projectDeviceLocation.length && 0 !== this.projectDeviceLocation.length) {
                exact *= this.projectDeviceLocation.length;
            }
            let rounded = Math.round(exact * 1000);
            rounded = 0 !== rounded ? rounded / 1000 : 0;
            return {exact, rounded};
        };

        return {past: computeDifference(value, previousValue), future: computeDifference(value, nextValue)};
    }

    private doNotDisplaySeries(unit) {
        if ('TEMPERATURE' === unit) {
            return !TEMPERATURE_DEVICE_TYPES_WITH_ONE_UNIT.includes(this.deviceType);
        }
    }
}

export interface MeasureInfosForSmartOffset {
    date: number;
    offset: any;
    locationId: number;
}
